<template>
  <div
    v-if="routerView"
    class="app-main-container"
    :class="{ 'index-container': $route.meta.title === '首页' }"
  >
    <component :is="searchComp" v-if="searchComp" :pattern="pattern" />

    <transition v-else mode="out-in" name="fade-transform">
      <keep-alive :include="['MyTask', 'TemplatePreview', 'homePage']">
        <router-view :key="$route.path" class="app-main-height" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
  import { title } from '@/config'

  export default {
    name: 'HtAppMain',
    data() {
      return {
        title,
        routerView: true,

        // 搜索组件
        searchComp: null,
        pattern: '',
      }
    },

    created() {
      //重载所有路由
      this.$baseEventBus.$on('reload-router-view', () => {
        this.routerView = false
        this.$nextTick(() => {
          this.routerView = true
        })
      })

      this.$baseEventBus.$on('nav-search-event', this.handleNavSearchEvent)
    },

    beforeDestroy() {
      this.$baseEventBus.$off('nav-search-event', this.handleNavSearchEvent)
    },

    methods: {
      handleNavSearchEvent({ type, pattern }) {
        if (!pattern) {
          this.searchComp = null
          return
        }
        this.pattern = pattern

        switch (type) {
          case 'user':
            this.searchComp = 'ht-user-list'
            break
          case 'flow':
            this.searchComp = 'ht-flow-list'
            break
          case 'document':
            this.searchComp = 'ht-document-list'
            break
          default:
            this.searchComp = null
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .app-main-container {
    position: relative;
    flex: 1;
    overflow: hidden auto;
    border-radius: 4px;

    .app-main-height {
      height: $base-app-main-height;
    }

    ::v-deep {
      .el-tabs__item {
        padding: 0 15px;
      }
    }
  }

  .index-container {
    overflow-y: scroll;
  }
</style>
